<!-- Versão corrigida v3 final: clusters sobrepostos abrem a lista de famílias. -->
<template>
  <div>
    <div>
      <div v-show="showMap && !loadHome" class="row px-3">
        <form-input-group
          class="px-0"
          type="search"
          v-model="search"
          btn-class="btn input-group-text border-left-0 p-2 bg-white"
          icon-btn="mdi mdi-magnify mdi-18px"
          placeholder="Buscar endereço ou Responsável familiar"
          @submit="filtrarResultados"
          @input="filtrarResultados"
          :grid="filtroShow ? '9' : '12'"
        />

        <div v-if="filtroShow" class="col-md-3 col-sm-12 pr-0">
          <button
            class="btn btn-sm btn-default btn-block mx-0 mb-3 px-2 py-1 d-flex align-items-center"
            @click="showFiltro = !showFiltro"
          >
            <i
              class="mdi mdi-18px"
              :class="showFiltro ? 'mdi-filter-off' : 'mdi-filter'"
            ></i>
            {{ showFiltro ? "Esconder filtros" : "Mostrar filtros" }}
          </button>
        </div>
      </div>

      <div class="col-12 px-0" v-show="showFiltro && !loadHome">
        <Filtro
          @cor="filtrarMarcadores"
          @sexo="filtrarMarcadores"
          @situacao_rua="filtrarMarcadores"
          @trabalho_infantil="filtrarMarcadores"
          @programa_social="filtrarMarcadores"
          @idoso="filtrarMarcadores"
          @idade="filtrarMarcadores"
          @limpar="ClearFilter"
          @limpo="clearFiltrosData = false"
          :limpar="clearFiltrosData"
          :aba="aba"
          :programas="programas"
        />
      </div>

      <div class="col-12 px-0" v-if="!loadHome">
        <Header :dados="marcadores" :aba="aba" />
      </div>

      <div
        v-show="showMap"
        id="mapContainer"
        :style="'height:' + height + ' width: 100%'"
        ref="hereMap"
      ></div>

      <div v-show="!showMap" id="boxPrint" ref="boxPrint">
        <img :src="imagem" alt="" width="100%" />
        <div id="panel" ref="panel"></div>
        <Show v-if="botaoimprimir !== 'none'" :dados="markers" />
      </div>

      <div
        class="row px-3 py-2 d-flex justify-content-end"
        :style="'display:' + botaoimprimir + '!important;'"
      >
        <button
          class="btn btn-default m-0 btn-sm"
          v-if="showMap"
          @click="gerarImagemMapa"
        >
          <i class="mdi mdi-text-box-check-outline mdi-18px" />
          Gerar PDF
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import Show from "../Show";
import Filtro from "./Filtro";
import Header from "./Header";

export default {
  name: "HereMap",

  components: {
    Show,
    Filtro,
    Header,
  },

  props: {
    center: {
      type: Object,
      default: () => ({}),
    },
    markers: {
      type: Array,
      default: () => [],
    },
    programas: {
      type: Array,
      default: () => [],
    },
    icon: {
      type: String,
      default: "",
    },
    aba: {
      type: String,
      default: "",
    },
    botaoimprimir: {
      type: String,
      default: "block",
    },
    height: {
      type: String,
      default: "600px;",
    },
    filtroShow: {
      type: Boolean,
      default: false,
    },
    loadHome: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      search: "",
      showMap: true,
      showFiltro: false,
      clearFiltrosData: false,
      platform: null,
      marcadoresTemp: [],
      marcadores: [],
      centro: {},
      centroTemp: {},
      map: null,
      ui: null,
      service: null,
      imagem: "",
      resizeHandler: null,
      clusteringLayer: null,
      clusteringProvider: null,
      clusteringTapHandler: null,
      filtros: {
        cor: "",
        sexo: "",
        situacao_rua: "",
        trabalho_infantil: "",
        programa_social: "",
        idoso: "",
        idade: "",
      },
      url: window.urlbase || window.location.origin + "/",
    };
  },

  watch: {
    icon() {
      this.ClearFilter();
    },

    markers: {
      handler(markers) {
        const novosMarcadores = Array.isArray(markers) ? markers.slice() : [];

        this.marcadoresTemp = novosMarcadores;
        this.marcadores = novosMarcadores.slice();
        this.ClearFilter();
      },
    },

    center: {
      deep: true,
      handler(center) {
        this.centro = center || {};
        this.centroTemp = center || {};

        if (this.platform && this.isValidCenter(this.centro)) {
          this.reloadMap();
        }
      },
    },
  },

  mounted() {
    this.marcadoresTemp = this.markers.slice();
    this.marcadores = this.markers.slice();
    this.centro = this.center || {};
    this.centroTemp = this.center || {};

    const apiKey = process.env.MIX_HERE_MAPS_API_KEY;

    if (!apiKey) {
      console.error("MIX_HERE_MAPS_API_KEY não foi incluída no bundle");
      return;
    }

    if (!window.H || !window.H.service) {
      console.error("A biblioteca JavaScript da HERE não foi carregada");
      return;
    }

    this.platform = new window.H.service.Platform({
      apikey: apiKey,
    });

    this.service = this.platform.getSearchService();
    this.reloadMap();
  },

  beforeDestroy() {
    this.disposeMap();
  },

  methods: {
    isValidCenter(center) {
      const lat = Number(center && center.lat);
      const lng = Number(center && center.lng);

      return Number.isFinite(lat) && Number.isFinite(lng);
    },

    ClearFilter() {
      this.marcadores = this.marcadoresTemp.slice();
      this.centro = this.centroTemp;
      this.filtros = {
        cor: "",
        sexo: "",
        situacao_rua: "",
        trabalho_infantil: "",
        programa_social: "",
        idoso: "",
        idade: "",
      };
      this.clearFiltrosData = true;
      this.reloadMap();
    },

    filterMarcadoresMembros(membro) {
      if (this.filtros.cor !== "" && this.filtros.idoso == 1) {
        return (
          parseInt(membro.cor_raca) == this.filtros.cor &&
          parseInt(membro.idade) > 60
        );
      }

      if (this.filtros.cor !== "") {
        return parseInt(membro.cor_raca) == this.filtros.cor;
      }

      if (this.filtros.idoso == 1) {
        return parseInt(membro.idade) > 60;
      }

      if (this.filtros.idade !== "") {
        const idade = parseInt(membro.idade);

        return idade >= this.filtros.idade[0] && idade <= this.filtros.idade[1];
      }

      return true;
    },

    filtrarMarcadores(value) {
      const key = Object.keys(value)[0];
      this.filtros[key] = value[key];

      this.marcadores = this.marcadoresTemp.filter((item) => {
        const dados = item.dados || {};
        const responsavel = dados.responsavel_familiar;
        const sexo = responsavel ? parseInt(responsavel.sexo) : "";
        const situacaoRua = parseInt(dados.situacao_rua) || null;
        const programaSocial = dados.programa_social || null;
        const trabalhoInfantil = parseInt(dados.trabalho_infantil) || null;
        const membrosOriginais = Array.isArray(dados.membros)
          ? dados.membros
          : [];
        let membros = membrosOriginais.filter((membro) =>
          this.filterMarcadoresMembros(membro),
        );

        if (this.filtros.sexo !== "") {
          if (sexo == this.filtros.sexo) {
            membros = membrosOriginais.filter((membro) =>
              this.filterMarcadoresMembros(membro),
            );
            return membros.length > 0;
          }

          return false;
        } else if (this.filtros.cor !== "") {
          membros = membrosOriginais.filter((membro) =>
            this.filterMarcadoresMembros(membro),
          );
          return membros.length > 0;
        } else if (this.filtros.situacao_rua !== "") {
          if (situacaoRua) {
            membros = membrosOriginais.filter((membro) =>
              this.filterMarcadoresMembros(membro),
            );
            return membros.length > 0;
          }

          return false;
        } else if (this.filtros.programa_social !== "") {
          return programaSocial
            ? programaSocial == this.filtros.programa_social
            : false;
        } else if (this.filtros.idade) {
          membros = membrosOriginais.filter((membro) =>
            this.filterMarcadoresMembros(membro),
          );
          return membros.length > 0;
        } else if (this.filtros.trabalho_infantil !== "") {
          if (trabalhoInfantil == 1) {
            membros = membrosOriginais.filter((membro) =>
              this.filterMarcadoresMembros(membro),
            );
            return membros.length > 0;
          }

          return false;
        } else if (
          this.filtros.sexo !== "" &&
          this.filtros.situacao_rua !== "" &&
          this.filtros.trabalho_infantil !== ""
        ) {
          if (
            situacaoRua &&
            trabalhoInfantil == 1 &&
            sexo == this.filtros.sexo
          ) {
            membros = membrosOriginais.filter((membro) =>
              this.filterMarcadoresMembros(membro),
            );
            return membros.length > 0;
          }

          return false;
        } else if (
          (this.filtros.sexo !== "" && this.filtros.situacao_rua !== "") ||
          this.filtros.trabalho_infantil !== ""
        ) {
          if (
            situacaoRua ||
            (trabalhoInfantil == 1 && sexo == this.filtros.sexo)
          ) {
            membros = membrosOriginais.filter((membro) =>
              this.filterMarcadoresMembros(membro),
            );
            return membros.length > 0;
          }

          return false;
        } else if (
          this.filtros.sexo !== "" ||
          (this.filtros.situacao_rua !== "" &&
            this.filtros.trabalho_infantil !== "")
        ) {
          if (
            (situacaoRua && trabalhoInfantil == 1) ||
            sexo == this.filtros.sexo
          ) {
            membros = membrosOriginais.filter((membro) =>
              this.filterMarcadoresMembros(membro),
            );
            return membros.length > 0;
          }

          return false;
        } else if (
          (this.filtros.sexo !== "" ||
            this.filtros.situacao_rua !== "" ||
            (this.filtros.trabalho_infantil !== "" &&
              this.filtros.trabalho_infantil == 1) ||
            this.filtros.idade !== "") &&
          this.filtros.programa_social !== ""
        ) {
          membros = membrosOriginais.filter((membro) =>
            this.filterMarcadoresMembros(membro),
          );

          if (
            this.filtros.programa_social &&
            programaSocial == this.filtros.programa_social
          ) {
            return membros.length > 0;
          }
        }

        return membros.length > 0;
      });

      this.reloadMap();
    },

    filtrarResultados() {
      const termo = String(this.search || "")
        .trim()
        .toLowerCase();

      if (!termo) {
        this.marcadores = this.marcadoresTemp.slice();
        this.centro = this.centroTemp;
        this.reloadMap();
        return;
      }

      this.marcadores = this.marcadoresTemp.filter((item) => {
        const dados = item.dados || {};
        const responsavel = dados.responsavel_familiar || {};
        const nomeResponsavel = String(
          responsavel.nome_completo || "",
        ).toLowerCase();
        const nomeSocialResponsavel = String(
          responsavel.nome_social || "",
        ).toLowerCase();
        const nomeLogradouro = String(
          dados.nome_logradouro || "",
        ).toLowerCase();

        return (
          nomeResponsavel.includes(termo) ||
          nomeSocialResponsavel.includes(termo) || nomeLogradouro.includes(termo)
        );
      });

      if (this.marcadores.length > 0) {
        const primeiroMarcador = this.marcadores[0];

        this.centro = {
          lat: primeiroMarcador.lat,
          lng: primeiroMarcador.lng,
        };
      }

      this.reloadMap();
    },

    initializeHereMap() {
      if (
        !this.platform ||
        !this.$refs.hereMap ||
        !this.isValidCenter(this.centro)
      ) {
        if (!this.isValidCenter(this.centro)) {
          console.error("Centro do mapa inválido:", this.centro);
        }

        return false;
      }

      const lat = Number(this.centro.lat);
      const lng = Number(this.centro.lng);
      const mapContainer = this.$refs.hereMap;
      const H = window.H;
      const maptypes = this.platform.createDefaultLayers({
        lg: "pt",
      });

      this.map = new H.Map(mapContainer, maptypes.vector.normal.map, {
        zoom: 10,
        center: { lat, lng },
        pixelRatio: window.devicePixelRatio || 1,
      });

      this.resizeHandler = () => {
        if (this.map) {
          this.map.getViewPort().resize();
        }
      };

      window.addEventListener("resize", this.resizeHandler);

      new H.mapevents.Behavior(new H.mapevents.MapEvents(this.map));

      this.ui = H.ui.UI.createDefault(this.map, maptypes, "pt-BR");

      return true;
    },

    configureMap() {
      if (!this.map) {
        return;
      }

      this.setInteractive(this.map);
      this.addContextMenus(this.map);
      this.addInfoBubble(this.map);
      this.showGeoJSONData(this.map);
    },

    reloadMap() {
      const mapContainer = this.$refs.hereMap;

      if (!this.platform || !mapContainer || !this.isValidCenter(this.centro)) {
        return;
      }

      this.disposeMap();
      mapContainer.innerHTML = "";

      if (!this.initializeHereMap()) {
        return;
      }

      this.configureMap();
    },

    disposeMap() {
      if (this.resizeHandler) {
        window.removeEventListener("resize", this.resizeHandler);
        this.resizeHandler = null;
      }

      if (this.clusteringProvider && this.clusteringTapHandler) {
        this.clusteringProvider.removeEventListener(
          "tap",
          this.clusteringTapHandler,
        );
      }

      if (this.map && typeof this.map.dispose === "function") {
        this.map.dispose();
      }

      this.map = null;
      this.ui = null;
      this.clusteringLayer = null;
      this.clusteringProvider = null;
      this.clusteringTapHandler = null;
    },

    setMarker(markers, map) {
      if (!Array.isArray(markers) || !map) {
        return;
      }

      markers.forEach((element) => {
        const lat = Number(element.lat);
        const lng = Number(element.lng);

        if (!Number.isFinite(lat) || !Number.isFinite(lng)) {
          return;
        }

        const icon = new window.H.map.Icon(this.icon);
        const coords = { lat, lng };
        const marker = new window.H.map.Marker(coords, {
          icon,
        });

        marker.setData(this.getHtmlpopUp(element));
        map.addObject(marker);
        map.setCenter(coords);
      });
    },

    gerarImagemMapa() {
      this.showMap = false;
      this.capture(this.map, this.ui);
    },

    print() {
      const modal = this.$refs.boxPrint;

      if (!modal) {
        return;
      }

      const cloned = modal.cloneNode(true);
      let section = document.getElementById("print");

      if (!section) {
        section = document.createElement("div");
        section.id = "print";
        document.body.appendChild(section);
      }

      section.innerHTML = "";
      section.appendChild(cloned);
      window.print();
    },

    capture(map, ui) {
      const resultContainer = this.$refs.panel;

      if (!map || !resultContainer) {
        return;
      }

      map.capture(
        (canvas) => {
          if (canvas) {
            this.imagem = canvas.toDataURL();
          } else {
            resultContainer.innerHTML = "Capturing is not supported";
          }
        },
        [ui],
        0,
        0,
        resultContainer.offsetWidth,
        resultContainer.offsetWidth,
      );
    },

    setInteractive(map) {
      const H = window.H;
      const provider = map.getBaseLayer().getProvider();
      const style = provider.getStyle();

      const changeListener = () => {
        if (style.getState() === H.map.Style.State.READY) {
          style.removeEventListener("change", changeListener);
          style.setInteractive(["places", "places.populated-places"], true);
          provider.addEventListener("tap", this.onTap);
        }
      };

      style.addEventListener("change", changeListener);
    },

    onTap(evt) {
      const position = this.map.screenToGeo(
        evt.currentPointer.viewportX,
        evt.currentPointer.viewportY,
      );
      const props = evt.target.getData().properties;
      const content =
        '<div style="width:250px"><b>' +
        this.escapeHtml(props.name) +
        "</b>" +
        (props.population
          ? "<br /> População: " + this.escapeHtml(props.population)
          : "") +
        "</div>";
      const bubble = new window.H.ui.InfoBubble(position, {
        content,
      });

      this.ui.addBubble(bubble);
    },

    startClustering(data, map) {
      if (!map) {
        return;
      }

      const H = window.H;

      if (!H.clustering || !H.clustering.Provider) {
        console.error(
          "A biblioteca mapsjs-clustering.js da HERE não foi carregada",
        );
        return;
      }

      const dados = Array.isArray(data) ? data : [];
      const dataPoints = dados
        .map((element) => ({
          lat: Number(element.lat),
          lng: Number(element.lng),
          element,
        }))
        .filter(
          (item) => Number.isFinite(item.lat) && Number.isFinite(item.lng),
        )
        .map(
          (item) =>
            new H.clustering.DataPoint(item.lat, item.lng, 1, item.element),
        );

      if (dataPoints.length === 0) {
        return;
      }

      const markerIcon = new H.map.Icon(this.icon);
      const theme = {
        getClusterPresentation: (cluster) => {
          const weight = cluster.getWeight();
          const radius = Math.min(30, 18 + Math.log(Math.max(weight, 2)) * 3);
          const diameter = radius * 2;
          const svg =
            '<svg xmlns="http://www.w3.org/2000/svg" ' +
            `width="${diameter}" height="${diameter}">` +
            `<circle cx="${radius}" cy="${radius}" ` +
            `r="${radius - 2}" fill="#2f80ed" ` +
            'stroke="#ffffff" stroke-width="3" />' +
            `<text x="${radius}" y="${radius + 5}" ` +
            'text-anchor="middle" fill="#ffffff" ' +
            'font-family="Arial, sans-serif" ' +
            'font-size="13" font-weight="700">' +
            `${weight}</text></svg>`;
          const icon = new H.map.Icon(svg, {
            size: { w: diameter, h: diameter },
            anchor: { x: radius, y: radius },
          });
          const marker = new H.map.Marker(cluster.getPosition(), {
            icon,
            min: cluster.getMinZoom(),
            max: cluster.getMaxZoom(),
          });

          marker.setData(cluster);

          return marker;
        },

        getNoisePresentation: (noisePoint) => {
          const marker = new H.map.Marker(noisePoint.getPosition(), {
            icon: markerIcon,
            min: noisePoint.getMinZoom(),
          });

          marker.setData(noisePoint);

          return marker;
        },
      };

      this.clusteringProvider = new H.clustering.Provider(dataPoints, {
        clusteringOptions: {
          eps: 32,
          minWeight: 2,
        },
        theme,
      });

      this.clusteringLayer = new H.map.layer.ObjectLayer(
        this.clusteringProvider,
      );

      this.clusteringTapHandler = (evt) => {
        const marker = evt.target;
        const item =
          marker && typeof marker.getData === "function"
            ? marker.getData()
            : null;

        if (!item || typeof item.isCluster !== "function") {
          return;
        }

        if (item.isCluster()) {
          const elementosDoCluster = this.getClusterElements(item);

          if (
            elementosDoCluster.length > 1 &&
            this.haveSameCoordinates(elementosDoCluster) &&
            this.ui
          ) {
            const bubble = new H.ui.InfoBubble(item.getPosition(), {
              content: this.getClusterListHtml(elementosDoCluster),
            });

            this.ui.addBubble(bubble);
            return;
          }

          const bounds =
            typeof item.getBoundingBox === "function"
              ? item.getBoundingBox()
              : null;

          if (bounds) {
            map.getViewModel().setLookAtData({ bounds }, true);
          } else {
            map.setCenter(item.getPosition(), true);
            map.setZoom(Math.min(map.getZoom() + 2, 20), true);
          }

          return;
        }

        const elemento = item.getData();

        if (!elemento || !this.ui) {
          return;
        }

        const bubble = new H.ui.InfoBubble(item.getPosition(), {
          content: this.getHtmlpopUp(elemento),
        });

        this.ui.addBubble(bubble);
      };

      this.clusteringProvider.addEventListener(
        "tap",
        this.clusteringTapHandler,
      );

      map.addLayer(this.clusteringLayer);
    },

    addContextMenus(map) {
      const H = window.H;

      map.addEventListener("contextmenu", function (event) {
        if (event.target !== map) {
          return;
        }

        const coord = map.screenToGeo(event.viewportX, event.viewportY);

        event.items.push(
          new H.util.ContextItem({
            label: [
              Math.abs(coord.lat.toFixed(4)) + (coord.lat > 0 ? "N" : "S"),
              Math.abs(coord.lng.toFixed(4)) + (coord.lng > 0 ? "E" : "W"),
            ].join(" "),
          }),
          new H.util.ContextItem({
            label: "Centralizar mapa aqui",
            callback: function () {
              map.setCenter(coord, true);
            },
          }),
        );
      });
    },

    addMarkerToGroup(group, coordinate, html) {
      const lat = Number(coordinate && coordinate.lat);
      const lng = Number(coordinate && coordinate.lng);

      if (!Number.isFinite(lat) || !Number.isFinite(lng)) {
        return;
      }

      const H = window.H;
      const icone = new H.map.Icon(this.icon);
      const marker = new H.map.Marker({ lat, lng }, { icon: icone });

      marker.setData(html);
      group.addObject(marker);
    },

    escapeHtml(value) {
      return String(value == null ? "" : value)
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#039;");
    },

    getClusterElements(cluster) {
      if (!cluster || typeof cluster.forEachDataPoint !== "function") {
        return [];
      }

      const elementos = [];

      cluster.forEachDataPoint((dataPoint) => {
        if (
          !dataPoint ||
          typeof dataPoint.getData !== "function" ||
          typeof dataPoint.getPosition !== "function"
        ) {
          return;
        }

        const element = dataPoint.getData();
        const position = dataPoint.getPosition();
        const lat = Number(position && position.lat);
        const lng = Number(position && position.lng);

        if (element && Number.isFinite(lat) && Number.isFinite(lng)) {
          elementos.push({ element, lat, lng });
        }
      });

      return elementos;
    },

    haveSameCoordinates(elementos) {
      if (!Array.isArray(elementos) || elementos.length < 2) {
        return false;
      }

      const primeiro = elementos[0];
      const tolerancia = 0.00000001;

      return elementos.every(
        (item) =>
          Math.abs(item.lat - primeiro.lat) <= tolerancia &&
          Math.abs(item.lng - primeiro.lng) <= tolerancia,
      );
    },

    getClusterListHtml(elementos) {
      const familias = [];
      const familiasIncluidas = new Set();

      elementos.forEach((item, index) => {
        const element = item && item.element;
        const dados = element && element.dados ? element.dados : {};

        if (!element || !element.dados) {
          return;
        }

        const identificador = dados.id ? `id:${dados.id}` : `indice:${index}`;

        if (familiasIncluidas.has(identificador)) {
          return;
        }

        familiasIncluidas.add(identificador);
        familias.push(element);
      });

      familias.sort((familiaA, familiaB) => {
        const dadosA = familiaA.dados || {};
        const dadosB = familiaB.dados || {};
        const responsavelA =
          (dadosA.responsavel_familiar || {}).nome_completo || "";
        const responsavelB =
          (dadosB.responsavel_familiar || {}).nome_completo || "";

        return responsavelA.localeCompare(responsavelB, "pt-BR");
      });

      const itensHtml = familias
        .map((element) => {
          const dados = element.dados || {};
          const responsavel = dados.responsavel_familiar || {};
          const nomeResponsavel = this.escapeHtml(
            responsavel.nome_completo || "Responsável não informado",
          );
          const identificacao = dados.id
            ? `Família ${this.escapeHtml(dados.id)} — `
            : "";

          return (
            '<details style="border-bottom:1px solid #e5e7eb;padding:8px 0">' +
            '<summary style="cursor:pointer;line-height:1.4">' +
            `<b>${identificacao}${nomeResponsavel}</b>` +
            "</summary>" +
            '<div style="padding:8px 4px 2px 14px">' +
            this.getHtmlpopUp(element) +
            "</div>" +
            "</details>"
          );
        })
        .join("");

      return (
        '<div style="width:460px;max-width:100%">' +
        `<b>${familias.length} famílias nesta localização</b>` +
        '<div style="margin-top:6px;color:#4b5563">' +
        "Selecione uma família para visualizar os dados." +
        "</div>" +
        '<div style="margin-top:6px">' +
        itensHtml +
        "</div>" +
        "</div>"
      );
    },

    getHtmlpopUp(element) {
      if (!element || !element.dados) {
        return "";
      }

      const dados = element.dados;
      const baseUrl = String(this.url || "").replace(/\/+$/, "");
      const roleDetails =
        this.$store.state.user && this.$store.state.user.role_details;
      const podeEditar = !roleDetails || roleDetails.name !== "Nível Básico";
      const responsavel = dados.responsavel_familiar || {};
      const nomeResponsavel = this.escapeHtml(responsavel.nome_completo || "");
      const quantidadeMembros = Array.isArray(dados.membros)
        ? dados.membros.length
        : Number(dados.membros_count) || 0;
      const vulnerabilidades = Array.isArray(dados.vulnerabilidades)
        ? dados.vulnerabilidades
        : [];
      const violacoes = Array.isArray(dados.violacao) ? dados.violacao : [];
      const faixasEtarias = Array.isArray(dados.faixa_etaria)
        ? dados.faixa_etaria
        : [];

      let responsavelHtml = `<span>${nomeResponsavel}</span>`;

      if (podeEditar && dados.id) {
        const familyUrl =
          `${baseUrl}/dashboard/familias/edit/` + encodeURIComponent(dados.id);

        responsavelHtml =
          `<a href="${familyUrl}" ` +
          'target="_blank" rel="noopener noreferrer">' +
          `${nomeResponsavel}</a>`;
      }

      const vulnerabilidadesHtml = vulnerabilidades.length
        ? "<b>Vulnerabilidade(s)</b><br><ul>" +
          vulnerabilidades
            .map((item) => `<li>${this.escapeHtml(item)}</li>`)
            .join("") +
          "</ul><br>"
        : "";

      const violacoesHtml = violacoes.length
        ? "<b>Situação de Violação</b><br><ul>" +
          violacoes
            .map((item) => `<li>${this.escapeHtml(item)}</li>`)
            .join("") +
          "</ul><br>"
        : "";

      const programaSocialHtml = dados.programa_social
        ? "<b>Programas Sociais</b><br>" +
          this.escapeHtml(dados.programa_social) +
          "<br>"
        : "";

      const faixasEtariasHtml = faixasEtarias.length
        ? "<b>Faixa Etária</b><br><ul>" +
          faixasEtarias
            .map((item) => `<li>${this.escapeHtml(item)}</li>`)
            .join("") +
          "</ul><br>"
        : "";

      return `
                <div>
                    <b>Responsável Familiar</b><br>
                    ${responsavelHtml}
                </div>
                <div>
                    Quantidade de membros na família:
                    <b>${quantidadeMembros}</b><br>
                    ${vulnerabilidadesHtml}
                    ${violacoesHtml}
                    ${programaSocialHtml}
                    ${faixasEtariasHtml}
                </div>
            `;
    },

    addInfoBubble(map) {
      if (!map) {
        return;
      }

      this.startClustering(this.marcadores, map);
    },

    showGeoJSONData(map) {
      if (!map) {
        return;
      }

      const H = window.H;
      const baseUrl = String(this.url || "").replace(/\/+$/, "");
      const reader = new H.data.geojson.Reader(
        `${baseUrl}/enderecos/berlin.json`,
        {
          style: function (mapObject) {
            if (mapObject instanceof H.map.Polygon) {
              mapObject.setStyle({
                fillColor: "rgba(255, 0, 0, 0.5)",
                strokeColor: "rgba(0, 0, 255, 0.2)",
                lineWidth: 3,
              });
            }
          },
        },
      );

      reader.parse();
      map.addLayer(reader.getLayer());
    },

    getLocation() {
      if (!this.service) {
        return;
      }

      this.service.geocode(
        {
          q: "Rua Josias Nunes Andrade, 285, Ribeirópolis, Sergipe",
        },
        (result) => {
          if (result.items && result.items.length > 0) {
            this.setMarker([result.items[0].position], this.map);
          }
        },
        (error) => {
          console.error("Erro ao geocodificar endereço:", error);
        },
      );
    },
  },
};
</script>

<style lang="css">
.H_ib_body {
  overflow: auto !important;
  max-height: 300px !important;
  width: 500px !important;
}
</style>
